import React from 'react';
import { Button as ButtonBootstrap, Spinner } from 'react-bootstrap';
import type { ButtonProps as ButtonBootstrapProps } from 'react-bootstrap';

interface ButtonProps extends Omit<ButtonBootstrapProps, 'as'> {
  isLoading?: boolean;
  children: React.ReactNode;
  disabled?: boolean;
}

const SpinnerButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, isLoading, disabled, ...props }, ref) => {
    return (
      <ButtonBootstrap ref={ref} {...props} disabled={disabled || isLoading}>
        {isLoading && <Spinner animation="border" size="sm" className="me-1" />}
        {children}
      </ButtonBootstrap>
    );
  },
);

SpinnerButton.displayName = 'SpinnerButton';

export default SpinnerButton;
